import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { SlideCheckbox } from '../SlideCheckbox/SlideCheckbox.js';
export const SlideCheckboxGroup = JSX(({ value, onChange, items = [], multiple }) => {
    const handleChange = (newValue) => {
        if (!onChange) {
            return;
        }
        const hasAlready = value?.includes(newValue);
        if (multiple) {
            onChange(hasAlready ? (value || []).filter((v) => v !== newValue) : [...(value || []), newValue]);
        }
        else {
            onChange(hasAlready ? [] : [newValue]);
        }
    };
    return items.map((item) => (_jsx(SlideCheckbox, { text: item?.title, value: [value].flatMap((_) => _).includes(item.value), onChange: () => handleChange(item.value), type: multiple ? 'checkbox' : 'radio' }, item.value)));
});
//# sourceMappingURL=SlideCheckboxGroup.js.map